var map = {
	"./sticker-0.png": 3200,
	"./sticker-1.png": 7850,
	"./sticker-2.png": 8902,
	"./sticker-3.png": 8045,
	"./sticker-4.png": 4562,
	"./sticker-5.png": 7483,
	"./sticker-6.png": 7636,
	"./sticker-7.png": 8532,
	"./sticker-8.png": 5538
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2716;